import { render, staticRenderFns } from "./@PopupSection.vue?vue&type=template&id=919c7998&"
import script from "./@PopupSection.vue?vue&type=script&lang=js&"
export * from "./@PopupSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports